(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = global || self, factory(global.dni = {}));
}(this, (function (exports) { 'use strict';

    function random(seed) {
        var _seed = seed % 2147483647;
        if (_seed <= 0)
            _seed += 2147483646;
        return {
            next: function () {
                _seed = (_seed * 16807) % 2147483647;
                return _seed;
            }
        };
    }
    var _letter = function (x) { return "trwagmyfpdxbnjzsqvhlcke"[+x % 23]; };
    var _randStrLimit = function (limit) { return ("" + Math.random()).slice(-limit); };
    var _randFloat = function (seed) { return (random(seed).next() - 1) / 2147483646; };

    var ctrlChar = function (y) {
        var f = "xyzXYZ".indexOf(y[0]) % 3;
        var s = f.toString();
        if (f === -1)
            s = y[0];
        var i = "" + s + y.slice(1, 8);
        return _letter(i).toUpperCase();
    };

    var _isNIE = function (v) {
        return /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$/i.test(v);
    };

    var isNIE = function (value) {
        return (!!value &&
            value.length === 9 &&
            _isNIE(value) &&
            ctrlChar(value) === value[8].toUpperCase());
    };

    var _isNIF = function (v) {
        return /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$/i.test(v);
    };

    var isNIF = function (value) {
        return (!!value &&
            value.length === 9 &&
            _isNIF(value) &&
            ctrlChar(value) === value[8].toUpperCase());
    };

    var isValid = function (value) {
        var dni = !value ? "" : value;
        if (dni.length !== 9 && !_isNIE(dni) && !_isNIF(dni)) {
            return false;
        }
        var f = "xyzXYZ".indexOf(dni[0]) % 3;
        var s = f.toString();
        if (f === -1) {
            s = dni[0];
        }
        var i = +(s + dni.slice(1, 8)) % 23;
        return "trwagmyfpdxbnjzsqvhlcket".indexOf(dni[8].toLowerCase()) === i;
    };

    var normalize = function (value) {
        return value.replace(/[-_\s]/gi, "").toUpperCase();
    };

    var randomNIE = function () {
        var r = Math.floor(Math.random() * 3);
        var nn = _randStrLimit(7);
        var l = _letter("" + r + nn).toUpperCase();
        return "" + "XYZ"[r] + nn + l;
    };

    var randomNIEWith = function (xyz, l, seed) {
        if (seed === void 0) { seed = 100000000 * Math.random(); }
        var headNum = "xyzXYZ".indexOf(xyz) % 3;
        if (headNum === -1) {
            return null;
        }
        var lastNum = "trwagmyfpdxbnjzsqvhlckeTRWAGMYFPDXBNJZSQVHLCKE".indexOf(l) % 23;
        if (lastNum === -1) {
            return null;
        }
        var headOne = headNum + 1;
        var num = Math.floor(1000000 * headOne + (9999999 - 1000000 * headOne - 23) * _randFloat(seed));
        var b = +("" + headNum + num);
        var rest = b % 23;
        var h = b - rest + lastNum;
        var s = ("0" + h + l).slice(-8);
        return ("" + xyz + s).toUpperCase();
    };

    var randomNIF = function () {
        var nn = _randStrLimit(8);
        return nn + _letter(nn).toUpperCase();
    };

    var randomNIFWith = function (char, seed) {
        if (seed === void 0) { seed = 100000000 * Math.random(); }
        var lastNum = "trwagmyfpdxbnjzsqvhlckeTRWAGMYFPDXBNJZSQVHLCKE".indexOf(char) % 23;
        if (lastNum === -1) {
            return null;
        }
        var n = 99999998 - 4347826 * (Math.floor(_randFloat(seed) * 22) + 1);
        var d = Math.max(0, n) % 23;
        var h = n + (lastNum - d);
        var s = ("0" + h).slice(-8);
        return ("" + s + char).toUpperCase();
    };

    exports.ctrlChar = ctrlChar;
    exports.isNIE = isNIE;
    exports.isNIF = isNIF;
    exports.isValid = isValid;
    exports.normalize = normalize;
    exports.randomNIE = randomNIE;
    exports.randomNIEWith = randomNIEWith;
    exports.randomNIF = randomNIF;
    exports.randomNIFWith = randomNIFWith;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.js.map
